<template>
  <section class="group">
    <b-collapse :open="true" class="card" style="border-radius: 8px;box-shadow: none">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title is-capitalized" :class="{ 'active': isActive }">
          <span @click.stop="toggle_group_classes()" class="toggle-icon is-flex" style="border-right:0;padding-left: 6px;">
            <img v-if="active" src="@/assets/icons/eye.svg"  />
            <img v-else src="@/assets/icons/eye-inactive.svg"  />
            <!-- <i class="fa" :class="{'fa-eye':active,'fa-eye-slash':!active}"></i> -->
          </span>
          <span class="is-medium-16-500-19">{{group[0].group}}</span>
        </p>
        <a class="card-header-icon">
          <svg viewBox="0 0 100 100" class="image is-24x24 mr-10">
            <use v-if="!props.open" xlink:href="@/assets/icons/sprite.svg#collapse" />
            <use v-else xlink:href="@/assets/icons/sprite.svg#expand" />
          </svg>
        </a>
      </div>
      <div class="card-content">
        <vector
          v-for="vector in group"
          :key="vector.class_id"
          :vector="vector"
          :is_group_active="active"
        ></vector>
      </div>
    </b-collapse>
  </section>
</template>
<script>
import Vector from "./vector.component";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
export default {
  data: function() {
    return {
      active: true
    };
  },
  components: {
    Vector
  },
  computed: {
    ...mapState(["active_layer"]),
    isActive() {
      return _.includes(this.group, this.active_layer);
    }
  },
  methods: {
    toggle_group_classes() {
      this.active = !this.active;
    }
  },
  props: ["group"]
};
</script>
<style lang="scss" scoped>
.group {
  margin-top: 10px;
  box-shadow: 0 3px 6px 0 rgba(92, 126, 247, 0.3);
  border-radius: 10px;
  .card-header-title {
    font-family: Barlow;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: left;
    color: #171e48;

    margin: 0;
    padding: 0;
    // font-size: 0.75rem;
    .toggle-icon {
      display: inline-block;
      height: 100%;
      border-right: 1px solid #d8dade;
      margin-right: 1rem;
      margin-left: 0.5rem;
    }
    .fa {
      height: 100%;
      margin-right: 1rem;
      margin-left: 0.5rem;
      display: flex;
      align-items: center;
    }
  }
  .active {
    color: #000;
    font-weight: 500;
  }
  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0.5rem;
  }
}

</style>
